import { render, staticRenderFns } from "./SubjectToken.vue?vue&type=template&id=0c85d1de"
import script from "./SubjectToken.vue?vue&type=script&lang=js"
export * from "./SubjectToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports